import { Box } from "@mui/material";
import React from "react";
import backgroundConfig from "./backgroundConfig";
import styles from "./BackgroundLayout.module.scss";
import FooterComponent from "../footer-component/FooterComponent";
import { BackgroundVariant } from "../../utility/interfaces/carePlanInterfaces";

interface BackgroundLayoutProps {
  children: React.ReactNode;
  variant?: BackgroundVariant;
  height: { xs?: string; sm?: string; md?: string };
  footer?: React.ReactNode;
  backgroundColor?: string;
  showFooter?: boolean;
  footerHeight?: string;
  backgroundFooterColor?: string;
}

const BackgroundLayout: React.FC<BackgroundLayoutProps> = ({
  children,
  variant = "default",
  height,
  footer,
  backgroundColor = "#fff",
  showFooter = true,
  footerHeight = "100px",
  backgroundFooterColor,
}) => {
  const { coverImage } = backgroundConfig[variant];

  return (
    <Box
      className={styles.container}
      sx={{
        backgroundColor,
        position: "relative",
        minHeight: "100vh",
      }}
    >
      {/* Background Image */}
      {coverImage && (
        <Box
          className={styles.coverImage}
          sx={{
            backgroundImage: `url(${coverImage})`,
            height: height,
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 0,
          }}
        />
      )}

      {/* Main Content Overlay including Footer */}
      <Box
        className={styles.contentOverlay}
        sx={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Box sx={{ flex: 1 }}>{children}</Box>
        {showFooter && (
          <FooterComponent
            backgroundColor={backgroundFooterColor}
            height={footerHeight}
          />
        )}
      </Box>
    </Box>
  );
};

export default BackgroundLayout;
